import {Editor} from '@tiptap/react';
import React from 'react';
import {useSelector} from 'react-redux';
import {ChainedCommands} from '@tiptap/core';
import {LinkEditorButton} from './LinkEditorButton';
import TextEditorButton from '../../../../../incase-domain/components/textEditor/TextEditorButton';
import {editorModeSelector} from '../../../../../store/selectors/tiptapEditor.selectors';
import {EditorModeEnum} from '../../../../../store/actions/types/tiptapEditor.types';

interface AdditionalFormatingToolbarProps {
    editor: Editor;
}

function AdditionalFormatingToolbar({editor}: AdditionalFormatingToolbarProps): JSX.Element {
    const editorMode = useSelector(editorModeSelector);

    const applyCommand = (fn: (chain: ChainedCommands) => ChainedCommands): void => {
        if (editorMode === EditorModeEnum.SELECT) {
            fn(editor.chain().selectAll()).run();
        } else {
            fn(editor.chain().focus()).run();
        }
    };

    const handleClearFormatting = (): void => {
        applyCommand((c) => c.clearNodes().unsetAllMarks());
    };

    return (
        <div style={{display: 'flex', flexDirection: 'row'}}>
            <TextEditorButton
                icon="ph:text-strikethrough"
                onClick={() => applyCommand((c) => c.toggleStrike())}
                isActive={editor.isActive('strike')}
            />
            <TextEditorButton
                icon="ph:text-subscript"
                onClick={() => applyCommand((c) => c.toggleSubscript())}
                isActive={editor.isActive('subscript')}
            />
            <TextEditorButton
                icon="ph:text-superscript"
                onClick={() => applyCommand((c) => c.toggleSuperscript())}
                isActive={editor.isActive('superscript')}
            />
            <LinkEditorButton editor={editor} />
            <TextEditorButton icon="solar:eraser-linear" onClick={handleClearFormatting} />
        </div>
    );
}

export default AdditionalFormatingToolbar;
